module.exports = __webpack_public_path__ + "fonts/deposit-guide-2-KVND.0bf2a3c2s.png";